import chicken_biriyani from './Biriyani/Chicken Biriyani.png'
import dum_biriyani from './Biriyani/Dum Biriyani.png'
import fusion_special from './Biriyani/Fusion Special.png'
import Ghee_rice from './Biriyani/Ghee Rice.png'
import mutton_biriyani from './Biriyani/Mutton Biriyani.png'
import spanish_rice from './Biriyani/Spanish Rice.png'
import chinese_fried_rice from './Biriyani/Chinese Fried Rice.png'
import bacon_fried_rice from './Biriyani/Bacon Fried Rice.png'
import malaysian_rice from './Biriyani/Malaysian Rice.png'
import american_nasi from './Biriyani/American Nasi.png'
import chicken_nasi from './Biriyani/Chicken Nasi Goreng.png'
import mixed_rice from './Biriyani/Mixed Rice.png'

const RiceItems = [
    {
        item_id: '01',
        item_name: 'Chicken Biriyani',
        item_image: chicken_biriyani,
        item_price: '1850',
        item_category:"rice"
    },
    {
        item_id: '02',
        item_name: 'Dum Biriyani',
        item_image: dum_biriyani,
        item_price: '1950',
        item_category:"rice"
    },
    {
        item_id: '03',
        item_name: 'Fusion Special',
        item_image: fusion_special,
        item_price: '1650',
        item_category:"rice"
    },
    {
        item_id: '04',
        item_name: 'Ghee Rice',
        item_image: Ghee_rice,
        item_price: '1150',
        item_category:"rice"
    },
    {
        item_id: '05',
        item_name: 'Mutton Biriyani',
        item_image: mutton_biriyani,
        item_price: '2100',
        item_category:"rice"
    },
    {
        item_id: '06',
        item_name: 'Spanish Rice',
        item_image: spanish_rice,
        item_price: '1700',
        item_category:"rice"
    },
    {
        item_id: '07',
        item_name: 'Chinese Fried Rice',
        item_image: chinese_fried_rice,
        item_price: '1950',
        item_category:"rice"
    },
    {
        item_id: '08',
        item_name: 'Bacon Fried Rice',
        item_image: bacon_fried_rice,
        item_price: '2100',
        item_category:"rice"
    },
    {
        item_id: '09',
        item_name: 'Malaysian Rice',
        item_image: malaysian_rice,
        item_price: '2350',
        item_category:"rice"
    },
    {
        item_id: '10',
        item_name: 'American Nasi Goreng',
        item_image: american_nasi,
        item_price: '2450',
        item_category:"rice"
    },
    {
        item_id: '11',
        item_name: 'Chicken Nasi Goreng',
        item_image: chicken_nasi,
        item_price: '2350',
        item_category:"rice"
    },
    {
        item_id: '12',
        item_name: 'Mixed Rice',
        item_image: mixed_rice,
        item_price: '2100',
        item_category:"rice"
    },
]

export default RiceItems